<template><div><h1>VUX V2.2.0 released</h1>
<h2><a href="/en/components/actionsheet.html">Actionsheet</a></h2>
<ul><li>[enhance] Donot update handel z-index in Safari when using v-transfer-dom</li>
</ul>
<h2><a href="/en/components/alert.html">Alert</a></h2>
<ul><li>[feature] Add prop:content</li>
</ul>
<h2><a href="/en/components/button-tab.html">ButtonTab</a></h2>
<ul><li>[enhance] Update border style(1px)</li>
</ul>
<h2><a href="/en/components/cell-form-preview.html">CellFormPreview</a></h2>
<ul><li>[feature] new component</li>
</ul>
<h2><a href="/en/components/cell.html">Cell</a></h2>
<ul><li>[feature] Support prop:is-loading</li>
</ul>
<h2><a href="/en/components/datetime-range.html">DatetimeRange</a></h2>
<ul><li>[enhance] Use better column width</li>
</ul>
<h2><a href="/en/components/datetime.html">Datetime</a></h2>
<ul><li>[fix] render picker on nextTick #1180</li>
</ul>
<h2><a href="/en/components/grid.html">Grid</a></h2>
<ul><li>[feature] Support dynamic rows</li>
<li>[enhance] Hide slot:icon and slot:label if not being set</li>
</ul>
<h2><a href="/en/components/scroller.html">Scroller</a></h2>
<ul><li>[fix] Fix issue when redirecting on scrolling #1187</li>
<li>[fix] Fix resize listener not being destroyed #1183</li>
</ul>
<h2><a href="/en/components/search.html">Search</a></h2>
<ul><li>[enhance] emit on-change after input</li>
</ul>
<h2><a href="/en/components/swipeout.html">Swipeout</a></h2>
<ul><li>[fix] Fix cannot scroll when disabled</li>
<li>[fix] Fix unable to trigger click event when disabled on android</li>
</ul>
<h2><a href="/en/components/x-address.html">XAddress</a></h2>
<ul><li>[enhance] Upgrade datas #1101</li>
</ul>
<h2><a href="/en/components/x-icon.html">XIcon</a></h2>
<ul><li>[enhance] Support all attributes #1147</li>
</ul>
<h2><a href="/en/components/transfer-dom.html">TransferDom</a></h2>
<ul><li>[enhance] Support simple entry name: TransferDom</li>
<li>[enhance] Add classname v-transfer-dom</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.2.0 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.2.0-90.vue?bbe3361e